const cred = {
    username: process.env.REACT_APP_USER,
    password: process.env.REACT_APP_PASS,
    usernameprod: process.env.REACT_APP_USER_PROD,
    usernameinv: process.env.REACT_APP_USER_INV,
};

export default cred;
